module.exports = __webpack_public_path__ + "static/abhinav-guntaka-8d9d7b539968dad2bcb92b4a7de9fc5d.png";